module.exports = __webpack_public_path__ + "static/media/leroy.7056386a.jpg";